import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders the thermal-receipt markup as a direct child of `<body>`.
 *
 * That placement is what makes the print stylesheet work: it collapses
 * every other body child with `display: none` so only the receipt defines
 * the printed page. If the receipt stayed nested inside the React tree,
 * hiding the app would hide the receipt with it — and merely setting the
 * app to `visibility: hidden` keeps its full layout height, which on an
 * `80mm auto` page stretches into metres of blank thermal paper and
 * shrinks the receipt to an unreadable speck.
 */
export function QmsPrintPortal({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  return createPortal(
    <div className="qms-print-host" aria-hidden>
      {children}
    </div>,
    document.body,
  );
}
